import { render, staticRenderFns } from "./OpportunityTable.vue?vue&type=template&id=3721382e&scoped=true&"
import script from "./OpportunityTable.vue?vue&type=script&lang=ts&"
export * from "./OpportunityTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3721382e",
  null
  
)

export default component.exports